import {
  ArcElement,
  CategoryScale,
  ChartDataset,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartJs from "chart.js/auto";
import "chartjs-adapter-moment";
import moment from "moment";

ChartJs.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ArcElement,
  TimeScale
);

function getDataSet({
  label,
  color,
  counts,
}: {
  label: string;
  color: string;
  counts: Record<string, { date: string; count: number }> | undefined | null;
}): ChartDataset<"line", { x: Date; y: number }[]> {
  return {
    fill: true,
    label,

    data:
      Object.values(counts || {})
        .sort((a, b) => {
          return (
            moment(a.date).toDate().getTime() -
            moment(b.date).toDate().getTime()
          );
        })
        .map((item) => ({
          x: moment(item.date).toDate(),
          y: item.count,
        })) || [],
    borderColor: color,
    backgroundColor: colorToRgba(color, 0.5) || "",
    tension: 0.4,
  };
}

export function rgbaToHex(color: string | null | undefined) {
  if (!color) return color;
  color = color.trim().toLowerCase();
  if (color.startsWith("rgba")) {
    let parts = color
      .replace("rgba(", "")
      .replace(")", "")
      .split(",")
      .map((part) => parseInt(part));
    return `#${parts[0].toString(16)}${parts[1].toString(
      16
    )}${parts[2].toString(16)}`;
  }
  return color;
}

export function colorToRgba(
  color: string | null | undefined,
  opacity: number = 1
) {
  if (!color) return color;
  color = color.trim().toLowerCase();
  if (color.startsWith("#")) {
    color = color.substring(1);
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);
    return `rgba(${r},${g},${b},${opacity})`;
  }

  if (color.startsWith("hsl")) {
    return color.replace("hsl", `hsla`).replace(")", `,${opacity})`);
  }
  if (color.startsWith("rgb")) {
    return color.replace("rgb", `rgba`).replace(")", `,${opacity})`);
  }
  if (color.startsWith("rgba")) {
    return color.replace(/,([^,]+)\)/, `,${opacity})`);
  }
  return color;
}

function generateRandomDataSet({
  label,
  startDate,
  min,
  max,
  endDate,
  isCumulative,
  color,
  maxIncrement = 3,
  dateIncrement = 1,
}: {
  label: string;
  startDate: string;
  min: number;
  max: number;
  endDate: string;
  isCumulative: boolean;
  color: string;
  maxIncrement?: number;
  dateIncrement?: number;
}) {
  let data = [];
  let date = moment(startDate);
  let count = 0;
  let lastValue = 0;
  while (moment(date).isBefore(moment(endDate))) {
    max = max + maxIncrement;
    let value = Math.floor(Math.random() * (max - min) + min);
    if (isCumulative) {
      value = lastValue + value;
      lastValue = value;
    }
    data.push({
      x: date,
      y: value,
    });
    date = moment(date).add(dateIncrement, "day");
    count++;
    if (count > 200) break;
  }
  return {
    fill: true,
    label,

    data: data,
    borderColor: color,
    backgroundColor: colorToRgba(color, 0.5) || "",
    tension: 0.4,
  };
}

export { getDataSet, generateRandomDataSet };
